// extracted by mini-css-extract-plugin
module.exports = {"edgeFade":"styles_edgeFade__5I2Om","couponsFadeLeft":"styles_couponsFadeLeft__tbb1g","couponsFadeRight":"styles_couponsFadeRight__t9VV2"};